import {HttpResponse, HttpService} from "./http.service";
import {FilterCategoryModel} from "../models/filter-category.model";
import {FilterPublisherModel} from "../models/filter-publisher.model";
import {FilterTagModel} from "../models/filter-tag.model";
import {PaginationElasticSearchModel} from "../models/pagination-elastic-search.model";

export const SearchFilterService = {
    async getCategories(
        search: string,
        page = 1,
        perPage = 30
    ) {
        const response: HttpResponse<PaginationElasticSearchModel<FilterCategoryModel[]>> = await HttpService.get(`category/search/?query=${search}&page=${page}&per_page=${perPage}`);

        return response?.data.results || [];
    },
    async getPublishers(
        search: string,
        page = 1,
        perPage = 30
    ) {
        const response: HttpResponse<PaginationElasticSearchModel<FilterPublisherModel[]>> = await HttpService.get(`publisher/search/?query=${search}&page=${page}&per_page=${perPage}`);

        return response?.data.results || [];
    },
    async getTags(
        search: string,
        page = 1,
        perPage = 30
    ) {
        const response: HttpResponse<PaginationElasticSearchModel<FilterTagModel[]>> = await HttpService.get(`tag/search/?query=${search}&page=${page}&per_page=${perPage}`);

        return response?.data.results || [];
    },
}